import { Breadcrumbs, Link, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

const breadcrumbsMap = {
  dashboard: "Inicio",
  profile: "Mi perfil",
  agregarsuministro: "Agregar suministro",
  "/suministro/:id": "Suministro",
  facturaspago: "Facturas",
  mispagos:"Descarga de Facturas"
};

const BreadcrumbsNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;

  const breadcrumbs = [];
  const pathnames = pathname.split('/').filter(Boolean);

  for (let i = 0; i < pathnames.length; i++) {
    const currentPath = `/${pathnames.slice(0, i + 1).join('/')}`;

    // Rutas dinámicas con ID
    const dynamicRouteKey = Object.keys(breadcrumbsMap).find(key =>
      key.includes(":id") && new RegExp(`^${key.replace(":id","[0-9]+")}$`).test(currentPath)
    );

    if (dynamicRouteKey) {
      breadcrumbs.push({ label: breadcrumbsMap[dynamicRouteKey], to: currentPath });
      continue;
    }

    // Rutas normales
    const segment = pathnames[i];
    if (breadcrumbsMap[segment]) {
      breadcrumbs.push({ label: breadcrumbsMap[segment], to: currentPath });
    }
  }

  // Asegurarse que siempre haya "Inicio" al principio
  if (!breadcrumbs.length || breadcrumbs[0].label !== "Inicio") {
    breadcrumbs.unshift({ label: "Inicio", to: "/dashboard" });
  }

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 1 }}>
      {breadcrumbs.map((crumb, i) =>
        i === breadcrumbs.length - 1 ? (
          <Typography key={crumb.to} color="text.primary">
            {crumb.label}
          </Typography>
        ) : (
          <Link
            key={crumb.to}
            underline="hover"
            color="inherit"
            onClick={() => navigate(crumb.to)}
            sx={{ cursor: "pointer" }}
          >
            {crumb.label}
          </Link>
        )
      )}
    </Breadcrumbs>
  );
};

export default BreadcrumbsNav;

